export const QueryKeys = {
    MEDICAL_CERTIFICATE_ASSIGNED_TO_USER: 'mc-assigned-to-user',
    IHI_SEARCH_LOG_LIST: ['ihi-search-log-list'],
    HPII_SEARCH_LOG_LIST: ['hpii-search-log-list'],
    HPIO_SEARCH_LOG_LIST: ['hpio-search-log-list'],
    PROVIDER_AUDIT_LOG_LIST: ['provider-audit-log-list'],
    PRESCRIPTION_AUDIT_LOG_LIST: ['prescription-audit-log-list'],
    TWILIO_TOKEN: 'twilio-token',
    PAYSLIP_REPORT_GENERATION_LIST: ['payslip-report-generations'],
    PAYROLL_RUN_LIST: ['payroll-runs'],
    PATIENT_ACCOUNT_STATUS: ['patient-account-status'],
    XERO_HEALTH: ['xero-health'],
    XERO_ITEMS: ['xero-items'],
    XERO_ACCOUNTS: ['xero-accounts'],
    XERO_TAX_RATES: ['xero-tax-rates'],
    XERO_RATE_CARD: ['xero-rate-card'],
    AUTHENTICATION_METHODS: ['authentication-methods'],
    XeroContacts(search, page, pageSize, contactId) {
        return ['xero-contacts', search, page, pageSize, contactId ?? ''];
    },
    PayrollRun(id) {
        return ['payroll-run', id];
    },
    SearchACGsByName(name) {
        return ['search-acgs', name];
    },
    GetACGDetails(id) {
        return ['acg-details', id];
    },
    GetVirtualProductDetails(productId) {
        return ['mims-virtual-product-details', productId];
    },
    GetPbsDetails(pbsCode) {
        return ['mims-pbs-details', pbsCode];
    },
    GetExtemporaneousCodes() {
        return ['pbs-extemp-codes'];
    },
    GetPricing() {
        return ['pricing'];
    },
    FindMedicineCurationsByVirtualProductId(productId) {
        return ['medicine-curations-by-vp-id', productId];
    },
    GetProductDetails(id) {
        return ['mims-product-details', id];
    },
    GetMultipleProductDetails(ids) {
        return ['mims-product-details:multiple', ...ids];
    },
    GetCuratedMedicineDetails(medicineId) {
        return ['curated-medicine-details', medicineId];
    },
    SearchMedicine(word, category) {
        return ['search-meds', word, category ?? ''];
    },
    ConsultationList(page, statuses) {
        return ['medical-certificate-list', page, ...statuses];
    },
    ScriptDetails(reference, scriptId) {
        return ['script-details', reference, scriptId];
    },
    ConsultationDetails(reference) {
        return ['consultation', reference];
    },
    FetchPatientSupportNotes(reference) {
        return ['patient-support-notes', reference];
    },
    GetApn() {
        return ['apn'];
    },
    GetMimsEula() {
        return ['mims-eula'];
    },
    GetAvailableMobileLoyaltyReward(params) {
        return ['available-mobile-loyalty-reward', params];
    },
};
export const MutationKeys = {
    SignupOptions() {
        return ['signup-options'];
    },
    SocialSession() {
        return ['social-session'];
    },
    CreateAuthenticationChallenge() {
        return ['create-authentication-challenge'];
    },
    CompleteAuthenticationChallenge(id) {
        return ['complete-authentication-challenge', id];
    },
    UnlinkAuthenticationMethod(provider) {
        return ['unlink-authentication-method', provider];
    },
    SetPassword() {
        return ['set-password'];
    },
    UpdatePreferredCallTimes() {
        return ['update-preferred-call-times'];
    },
    DeleteAccount() {
        return ['delete-account'];
    },
    UpdateQuizState(type) {
        return ['update-quiz-state', type];
    },
    CreateTreatmentPaymentLink(type) {
        return ['create-treatment-payment-link', type];
    },
    CreateTreatmentMobilePayment(type) {
        return ['create-treatment-mobile-payment', type];
    },
    GenerateApn() {
        return ['generate-apn'];
    },
    AcceptMimsEula() {
        return ['accept-mims-eula'];
    },
    ApproveMedicalCertificate(reference) {
        return ['approve-mc', reference];
    },
    RegenerateMedicalCertificate(reference) {
        return ['regenerate-mc', reference];
    },
    ApproveSpecialistReferral(reference) {
        return ['approve-specialist-referral', reference];
    },
    ApprovePrescription(reference) {
        return ['approve-prescription', reference];
    },
    AbortPrescription() {
        return ['abort-prescription'];
    },
    PrescribeMedicine(reference) {
        return ['prescribe-medicine', reference];
    },
    RejectPrescription(reference) {
        return ['reject-prescription', reference];
    },
    DownloadPrescriptionPDF() {
        return ['download-prescription-patient-copy'];
    },
    CancelPrescription(reference, scriptId) {
        return ['cancel-prescription', reference, scriptId];
    },
    CancelEScript(reference, scriptId) {
        return ['cancel-e-script', reference, scriptId];
    },
    ReissueEScriptToken() {
        return ['reissue-e-script-token'];
    },
    SaveConsultNotes(reference) {
        return ['save-consult-notes', reference];
    },
    RequestMedicalCertificate() {
        return ['request-mc'];
    },
    RequestSpecialistReferral() {
        return ['request-specialist-referral'];
    },
    RequestSpecialistReferralMobilePayment() {
        return ['request-specialist-referral', 'mobile-payment'];
    },
    UpdateNewSpecialistReferral() {
        return ['update-new-specialist-referral'];
    },
    Signup() {
        return ['signup'];
    },
    CreatePasswordResetLink() {
        return ['create-password-reset-link'];
    },
    ResetPassword() {
        return ['reset-password'];
    },
    UpdatePatientProfile() {
        return ['update-patient-profile'];
    },
    StartTfaChallenge() {
        return ['start-account-creation-email-tfa-challenge'];
    },
    VerifyTfaChallenge() {
        return ['verify-account-creation-email-tfa-challenge'];
    },
    CreateAccount() {
        return ['create-account'];
    },
    UpdateAccount() {
        return ['update-account'];
    },
    UpdateProfile() {
        return ['update-profile'];
    },
    UpdatePassword() {
        return ['update-password'];
    },
    DownloadPayslipReport() {
        return ['download-payslip-report'];
    },
    DownloadPayrollRun() {
        return ['download-payroll-run'];
    },
    DownloadPayrollRunRcti() {
        return ['download-payroll-run-rcti'];
    },
    ApprovePayrollRun() {
        return ['approve-payroll-run'];
    },
    RebuildPayrollRun() {
        return ['rebuild-payroll-run'];
    },
    RetryPayrollRunFinalisation() {
        return ['retry-payroll-run-finalisation'];
    },
    UpdateOrCreateDoctorProfile() {
        return ['update-or-create-doctor-profile'];
    },
    UpdateXeroRateCard() {
        return ['update-xero-rate-card'];
    },
    UpdateOrCreateSupportAgentProfile() {
        return ['update-or-create-support-agent-profile'];
    },
    UpdateStoryQuestion(reviewId) {
        return ['update-story-question', reviewId];
    },
    RegenerateStoryReview(reviewId) {
        return ['regenerate-story-review', reviewId];
    },
    VerifyIHI() {
        return ['verify-ihi'];
    },
    CheckDuplicateIHI() {
        return ['check-duplicate-ihi'];
    },
    CheckDuplicateEmail() {
        return ['check-duplicate-email'];
    },
    VerifyPatientIHI(reference) {
        return ['verify-ihi', reference];
    },
    ValidatePatientEmail(reference) {
        return ['validate-patient-email', reference];
    },
    UpdatePatientEmail(reference) {
        return ['update-patient-email', reference];
    },
    RequestPrescription() {
        return ['request-prescription'];
    },
    RequestPrescriptionMobilePayment() {
        return ['request-prescription', 'mobile-payment'];
    },
    RequestGeneralConsultation() {
        return ['request-general-consultation'];
    },
    RequestGeneralConsultationMobilePayment() {
        return ['request-general-consultation', 'mobile-payment'];
    },
    RequestLabResultFollowUpMobilePayment(resultId) {
        return ['request-lab-result-follow-up', 'mobile-payment', resultId];
    },
    IssueOrUpdateMedicalCertificate(reference) {
        return ['issue-or-update-medical-certificate', reference];
    },
    DeleteMedicalCertificate(reference) {
        return ['delete-medical-certificate', reference];
    },
    DeleteSpecialistReferral(reference) {
        return ['delete-specialist-referral', reference];
    },
    DeleteGeneralLetter(reference) {
        return ['delete-general-letter', reference];
    },
    IssueOrUpdateSpecialistReferral(reference) {
        return ['issue-or-update-specialist-referral', reference];
    },
    IssueOrUpdatePathologyReferral(reference) {
        return ['issue-or-update-pathology-referral', reference];
    },
    IssueOrUpdateRadiologyReferral(reference) {
        return ['issue-or-update-radiology-referral', reference];
    },
    IssueOrUpdateGeneralLetter(reference) {
        return ['issue-or-update-letter', reference];
    },
    UploadReferralSupportingDocuments() {
        return ['upload-supporting-documents'];
    },
    UploadQuizPhotos() {
        return ['upload-quiz-photos'];
    },
    UploadQuizFiles() {
        return ['upload-quiz-files'];
    },
    SearchHPIO() {
        return ['search-hpio'];
    },
    VerifyIHIForPrescription(reference) {
        return ['verify-ihi', reference];
    },
    VerifyHpiiForPrescription(reference) {
        return ['verify-hpii', reference];
    },
    VerifyHpioForPrescription(reference) {
        return ['verify-hpio', reference];
    },
    UpdatePrescriptionCategory(id) {
        return ['update-prescription-category', id];
    },
    UpdateMedicineById(id) {
        return ['update-medicine-by-id', id];
    },
    DeleteMedicineById(id) {
        return ['delete-medicine-by-id', id];
    },
    CreateMedicineCategory() {
        return ['create-medicine-category'];
    },
    DeleteMedicineCategoryById(id) {
        return ['delete-medicine-category', id];
    },
    InvalidateMedicalCertificate() {
        return ['invalidate-medical-certificate'];
    },
    CurateMedicines() {
        return ['curate-medicines'];
    },
    UpdateCuratedMedicine(id) {
        return ['update-curated-medicine', id];
    },
    RemoveMedicinesFromCategory(categoryId) {
        return ['remove-medicines-from-category', categoryId];
    },
};
export const CacheKeys = {
    PrescriptionCategories() {
        return ['prescription-categories'];
    },
    PrescriptionCategoryDetails() {
        return ['prescription-category-details'];
    },
    PrescriptionCategoryByAlias(alias) {
        return [`prescription-category-${alias}`];
    },
    PrescriptionMedicine(categoryAlias, alias) {
        return [
            `prescription-category-${categoryAlias}`,
            `prescription-medicine-${categoryAlias}-${alias}`,
            `prescription-medicine-category-${categoryAlias}`,
        ];
    },
};
